export * from "./getInitialSticks";
